import React, { useState } from "react";
import { useScrollPosition } from "../hooks/useScrollPosition";
import useResizeObserver from "../hooks/useResizeObserver";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import { mainBody, repos, about, skills } from "../editable-stuff/config.js";
import { NavLink } from "./home/migration";

const appPath = (path = "/") => {
  const publicUrl = process.env.PUBLIC_URL || "";

  try {
    const parsed = new URL(publicUrl, "http://localhost");
    const basePath = parsed.pathname.replace(/\/+$/, "");
    const cleanPath = path.startsWith("/") ? path : `/${path}`;
    return `${basePath}${cleanPath}` || "/";
  } catch {
    const basePath = publicUrl.replace(/\/+$/, "");
    const cleanPath = path.startsWith("/") ? path : `/${path}`;
    return `${basePath}${cleanPath}` || "/";
  }
};

const Navigation = React.forwardRef((props, ref) => {
  // const { showBlog, FirstName } = config;
  const [isTop, setIsTop] = useState(true);
  const [scrollPosition, setScrollPosition] = useState(0);
  const navbarMenuRef = React.useRef();
  const handleResumeClick = (event) => {
    event.preventDefault();
    window.alert("Resume coming soon.");
  };

  const navbarDimensions = useResizeObserver(navbarMenuRef);
  const navBottom = navbarDimensions ? navbarDimensions.bottom : 0;
  useScrollPosition(
    ({ prevPos, currPos }) => {
      if (!navbarDimensions || !ref?.current) {
        setIsTop(true);
        return;
      }

      currPos.y + ref.current.offsetTop - navbarDimensions.bottom > 5
        ? setIsTop(true)
        : setIsTop(false);
      setScrollPosition(currPos.y);
    },
    [navBottom],
  );

  React.useEffect(() => {
    if (!navbarDimensions || !ref?.current) {
      setIsTop(true);
      return;
    }

    navBottom - scrollPosition >= ref.current.offsetTop
      ? setIsTop(false)
      : setIsTop(true);
  }, [navBottom, navbarDimensions, ref, scrollPosition]);

  return (
    <Navbar
      ref={navbarMenuRef}
      className={`site-navbar px-3 fixed-top ${
        !isTop ? "navbar-white" : "navbar-transparent"
      }`}
      expand="lg"
    >
      <Navbar.Brand className="navbar-brand brand-pill" href={appPath("/")}>
        {"TWSystems"}
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" className="toggler" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="navbar-nav ms-auto align-items-lg-center">
          {/* {
            <NavLink className="nav-item lead">
              <Link to={process.env.PUBLIC_URL + "/blog"}>Blog</Link>
            </NavLink>
          } */}
          {repos.show && (
            <NavLink className="nav-pill" href="#projects">
              Projects
            </NavLink>
          )}
          {/* <NavLink
            className="nav-pill"
            href="#resume-coming-soon"
            onClick={handleResumeClick}
            aria-label="Resume"
          >
            Resume
          </NavLink> */}
          {/* <NavLink className="nav-pill" href={appPath("/automation")}>
            Automation
          </NavLink> */}
          {about.show && (
            <NavLink className="nav-pill" href="#aboutme">
              About
            </NavLink>
          )}
          {skills.show && (
            <NavLink className="nav-pill" href="#skills">
              Skills
            </NavLink>
          )}
          <NavLink className="nav-cta" href="#getintouch">
            Let's Talk
          </NavLink>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
});

export default Navigation;
